import UIFetchService from '../Service/UIFetchService';

import { Button, Col, Input, message, Modal, Popconfirm, Row, Select, Table } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import React from 'react';

class UserTagsMetadataModal extends React.Component {

    uniqueKey = 1

    constructor() {
        super();
        this.state = {
            metadata: [],
        };
    }


    render() {
        return <Modal
            title="基础信息管理"
            visible={this.props.visible}
            onOk={this.saveAll.bind(this)}
            onCancel={this.props.onClose}
            maskClosable={false}
            width={870}
        >
            <Row>
                <Col flex='100%'>
                    <Table
                        size='small'
                        rowKey='key'
                        dataSource={this.state.metadata}
                        pagination={false}
                        scroll={{ y: 450, x: 800 }}
                        footer={() => <Row justify='center'>
                            <Col>
                                <Button
                                    icon={<PlusOutlined />}
                                    type='link'
                                    onClick={() => this.setState(({ metadata }) => {
                                        metadata.push({
                                            kind: 'BIZ_META',
                                            name: '',
                                            enumValues: '',
                                            desc: '',
                                            required: false,
                                            key: (this.uniqueKey++).toString()
                                        });
                                        return { metadata: [...metadata] };
                                    })}
                                >增加一条基础信息</Button>
                            </Col>
                        </Row>}
                        style={{ width: '100%' }}
                    >
                        <Table.Column
                            title="信息分类"
                            dataIndex='kind'
                            width={140}
                            render={(kind, rd) => <Select
                                value={kind}
                                onChange={value => this.setState(({ metadata }) => {
                                    rd.kind = value;
                                    return { metadata };
                                })}
                                size='small'
                                style={{ width: '100%' }}
                            >
                                <Select.Option value='BIZ_META'>业务元信息</Select.Option>
                                <Select.Option value='TECH_META'>技术元信息</Select.Option>
                                <Select.Option value='QUALITY_META'>质量元信息</Select.Option>
                            </Select>}
                        />
                        <Table.Column
                            title="字段名称"
                            dataIndex='name'
                            width={160}
                            render={(name, rd) => <Input
                                value={name}
                                onChange={({ target: { value } }) => this.setState(({ metadata }) => {
                                    rd.name = value;
                                    return { metadata };
                                })}
                                size='small'
                                style={{ width: '100%' }}
                            />}
                        />
                        <Table.Column
                            title="枚举值"
                            dataIndex='enumValues'
                            width={160}
                            render={(enumValues, rd) => <Input
                                value={enumValues}
                                placeholder='多个值以逗号分割'
                                onChange={({ target: { value } }) => this.setState(({ metadata }) => {
                                    rd.enumValues = value;
                                    return { metadata };
                                })}
                                size='small'
                                style={{ width: '100%' }}
                            />}
                        />
                        <Table.Column
                            title="说明"
                            dataIndex='desc'
                            width={180}
                            render={(desc, rd) => <Input
                                value={desc}
                                onChange={({ target: { value } }) => this.setState(({ metadata }) => {
                                    rd.desc = value;
                                    return { metadata };
                                })}
                                size='small'
                                style={{ width: '100%' }}
                            />}
                        />
                        <Table.Column
                            title="是否必填"
                            dataIndex='required'
                            width={100}
                            render={(required, rd) => <Select
                                value={required.toString()}
                                onChange={value => this.setState(({ metadata }) => {
                                    rd.required = value === 'true';
                                    return { metadata };
                                })}
                                size='small'
                                style={{ width: '100%' }}
                            >
                                <Select.Option value='true'>必填</Select.Option>
                                <Select.Option value='false'>选填</Select.Option>
                            </Select>}
                        />
                        <Table.Column
                            title="操作"
                            render={(_, rd, idx) => <Popconfirm
                                title="是否删除指定的基础信息？"
                                onConfirm={() => this.setState(({ metadata }) => {
                                    metadata = metadata.filter((_, i) => i !== idx);
                                    return { metadata };
                                })}
                            width={20}
                        >
                                <Button
                                    icon={<DeleteOutlined />}
                                    danger
                                    type='link'
                                    size='small'
                                >
                                </Button>
                            </Popconfirm>}
                        />
                    </Table>
                </Col>
            </Row>
        </Modal>;
    }

    async componentDidMount() {
        const metadata = await UIFetchService.get('/api/v1/user_tags/metadata');
        metadata.forEach(d => d.key = (this.uniqueKey++).toString());
        this.setState({ metadata });
    }

    async saveAll() {
        await UIFetchService.put('/api/v1/user_tags/metadata', this.state.metadata);
        message.success('保存成功');
        this.props.onClose();
    }
};

export default UserTagsMetadataModal;